<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_DEFAULT_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <!-- <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :disabled="true"
              :pageId="this.$options.name"
              :selectedMd="frame1.selectData.COD_MDLE"
              :selectedSmd="frame1.selectData.COD_SMDLE"
              :customMdList="optionCodes.selOption"
              :customSmdList="optionCodes.selOption"
            /> -->
            <sui-text-field
              v-model="frame1.moduleName"
              :readonly="true"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="frame1.subModuleName"
              :readonly="true"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model="frame1.programId"
              :readonly="true"
              maxlength="100"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model="frame1.programName"
              :disabled="false"
              :clearable="true"
              :readonly="false"
              maxlength="100"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-code-select
              ref="comboPrgType"
              :selected="frame1.selectData.COD_PRG_TYPE"
              :pageId="this.$options.name"
              codeId="COD_PRG_TYPE"
              :defaultOption="'select'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_TECHN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-code-select
              ref="comboPrgTechn"
              :selected="frame1.selectData.COD_PRG_TECHN"
              :pageId="this.$options.name"
              codeId="COD_PRG_TECHN"
              :defaultOption="'select'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-radio
              v-model="frame1.selectData.useYn"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="frame1.selectData.useYn"
              value="N"
            >
              No
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_CNTN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model="frame1.programContents"
              :disabled="false"
              maxlength="400"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <cmp-user-name-link
              :pageId="pageId"
              :displayType="'1'"
              :displayLanguageId="frame1.fstDisplayLanguageId"
              :knoxId="frame1.fstKnoxId"
              :userName="frame1.fstUserName"
              :userGlobalName="frame1.fstUserGlobalName"
              :departmentName="frame1.fstDepartmentName"
              :departmentEnglishName="frame1.fstDepartmentEnglishName"
              :type="'link'"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <div class="comm_label">
              {{ frame1.firstRegistrationDTM }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDFC_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <cmp-user-name-link
              :pageId="pageId"
              :displayType="'1'"
              :displayLanguageId="frame1.fnlDisplayLanguageId"
              :knoxId="frame1.fnlKnoxId"
              :userName="frame1.fnlUserName"
              :userGlobalName="frame1.fnlUserGlobalName"
              :departmentName="frame1.fnlDepartmentName"
              :departmentEnglishName="frame1.fnlDepartmentEnglishName"
              :type="'link'"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDFC_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <div class="comm_label">
              {{ frame1.finalModificationDTM }}
            </div>
          </div>
        </div>
      </div>

      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_FILE_INFO') }}</h4>
      </div>
      <sui-grid
        ref="grdfilelist"
        :columns="gridColumns0"
        :dataset="'dsFileLst'"
        :initialPagesize="5"
        :showDisplayCountControl="false"
        :enabletooltips="true"
        :multiselect="true"
      >
        <div class="comp_spacing" />
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickAddRow"
          >
            {{ $t('MSG_BTN_ROW_ADD') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickDelRow"
          >
            {{ $t('MSG_BTN_ROW_DEL') }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_ATTH_FILE') }}</h4>
      </div>
      <cmp-file-attacher
        ref="fileAttacher"
        :pageId="pageId"
        :showAddDeleteBtn="true"
        :showUpDownArrowBtn="true"
        :attachGroupId="attachGroupId"
        :attachDocumentId="attachDocumentId"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancelClick"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        v-permission:delete="'PGE_CMS_00006'"
        type="button"
        class="comm_btn_border"
        @click="onDelClick"
      >
        {{ $t('MSG_BTN_DEL') }}
      </sui-button>
      <sui-button
        v-permission:update="'PGE_CMS_00006'"
        type="button"
        class="comm_btn_solid"
        @click="onSaveClick"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

// const CODE_KEYS = ['COD_PRG_FILE_TYPE', 'COD_DTSVC_USE_YN'];
const CODE_KEYS = ['COD_PRG_FILE_TYPE'];
const gridEditorFactory = utils.getGridCellFactory();

export default {
  name: 'PGE_CMS_00006_P02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMS_00006',
    },
    programId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      optionCodes: CommonConstants.selectOptions(),
      codes: {
        COD_PRG_FILE_TYPE: [{ key: 'select', label: this.$t('MSG_TXT_SEL') }],
        // COD_DTSVC_USE_YN: [{ key: ' ', label: this.$t('MSG_TXT_SEL') }],
        COD_GRD_USE_YN: [
          { key: ' ', label: this.$t('MSG_TXT_SEL') },
          { key: 'Y', label: 'Yes' },
          { key: 'N', label: 'No' },
        ],
      },
      attachGroupId: 'ATG_CMS_PRGS_COMMON',
      attachDocumentId: '',
      frame1: {
        programId: '',
        moduleCode: '',
        subModuleCode: '',
        programName: '',
        programContents: '',
        firstRegistrationDTM: '',
        firstRegistrationUserId: '',
        finalModificationDTM: '',
        finalModificationUserId: '',
        selectData: {
          // COD_MDLE: {
          //   label: '',
          //   key: '',
          // },
          // COD_SMDLE: {
          //   label: '',
          //   key: '',
          // },
          COD_PRG_TYPE: {
            label: '',
            key: '',
          },
          COD_PRG_TECHN: {
            label: '',
            key: '',
          },
          useYn: '',
        },
      },
      count: 0,
      localdata1: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_FILE_NM'),
        datafield: 'fileName',
        createwidget: (row, column, value, htmlElement) => {
          // 텍스트필드
          const componentInstance = gridEditorFactory.createCellTextField(row, column, value, htmlElement, {
            trim: true,
            maxlength: 25,
          }, this.dsFileLst, this.$refs.grdfilelist);
          const instance = componentInstance.getComponentInstance();

          instance.$on('keyup', () => {
            const datasetEventData = utils.clone(componentInstance.dataset.data);
            const rowIndex = componentInstance.getDatasetIndex();
            const datasetEventRowData = datasetEventData[rowIndex];
            const searchFieldNewText = instance.$refs.refInput.value;

            instance.searchFieldOldText = utils.isEmpty(instance.searchFieldOldText)
              ? datasetEventRowData.fileName
              : instance.searchFieldOldText;

            if (utils.isExistSpecialChar(searchFieldNewText)) {
              utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
                componentInstance.dataset.setData(rowIndex, 'fileName', instance.searchFieldOldText);

                this.gridSetFocus(rowIndex, 'fileName');
              });
            } else {
              instance.searchFieldOldText = searchFieldNewText;
            }
          });
        },
        initwidget(row, column, value, htmlElement) {
          gridEditorFactory.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_FPATH'),
        datafield: 'filePath',
        createwidget: (row, column, value, htmlElement) => {
          // 텍스트필드
          const componentInstance = gridEditorFactory.createCellTextField(row, column, value, htmlElement, {
            trim: true,
            maxlength: 100,
          }, this.dsFileLst, this.$refs.grdfilelist);
          const instance = componentInstance.getComponentInstance();

          instance.$on('keyup', () => {
            const datasetEventData = utils.clone(componentInstance.dataset.data);
            const rowIndex = componentInstance.getDatasetIndex();
            const datasetEventRowData = datasetEventData[rowIndex];
            const searchFieldNewText = instance.$refs.refInput.value;

            instance.searchFieldOldText1 = utils.isEmpty(instance.searchFieldOldText)
              ? datasetEventRowData.filePath
              : instance.searchFieldOldText;

            if (utils.isOnlyKor(searchFieldNewText)) {
              utils.messageBox('warning', this.$t('MSG_ALT_INPUT_KOR'), null, () => {
                componentInstance.dataset.setData(rowIndex, 'filePath', instance.searchFieldOldText);

                this.gridSetFocus(rowIndex, 'filePath');
              });
            } else {
              instance.searchFieldOldText1 = searchFieldNewText;
            }
          });
        },
        initwidget(row, column, value, htmlElement) {
          gridEditorFactory.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_FILE_TYPE'),
        datafield: 'fileTypeCode',
        width: 100,
        createwidget: (row, column, value, htmlElement) => {
          gridEditorFactory.createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.codes.COD_PRG_FILE_TYPE,
            },
            this.dsFileLst, this.$refs.grdfilelist);
          // console.log(this.codes.COD_PRG_FILE_TYPE);
        },
        initwidget(row, column, value, htmlElement) {
          gridEditorFactory.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'fileUseYnCode',
        width: 80,
        createwidget: (row, column, value, htmlElement) => {
          // gridEditorFactory.createCellSelect(row, column, value, htmlElement,
          //   {
          //     optionList: this.codes.COD_GRD_USE_YN,
          //   },
          //   this.dsFileLst, this.$refs.grdfilelist);
          gridEditorFactory.createCellSegmentBox(
            row, column, value, htmlElement, {}, this.dsFileLst, this.$refs.grdfilelist,
          );
          // console.log(this.codes.COD_GRD_USE_YN);
        },
        initwidget(row, column, value, htmlElement) {
          gridEditorFactory.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_CNTN'),
        datafield: 'fileContent',
        width: 200,
        createwidget: (row, column, value, htmlElement) => {
          // 텍스트필드
          gridEditorFactory.createCellTextField(row, column, value, htmlElement, {
            trim: true,
            maxlength: 1000,
          }, this.dsFileLst, this.$refs.grdfilelist);
        },
        initwidget(row, column, value, htmlElement) {
          gridEditorFactory.refreshCell(row, column, value, htmlElement);
        },
      }],
      programIdCheckFlag: false,
      validMessage: '',
    };
  },
  datasets: [{
    id: 'dsFileLst',
    type: 'local',
    data: 'localdata1',
    datafields: [{
      name: 'fileName',
      type: 'string',
      map: 'fileName',
    }, {
      name: 'filePath',
      type: 'string',
      map: 'filePath',
    }, {
      name: 'fileTypeCode',
      type: 'string',
      map: 'fileTypeCode',
    }, {
      name: 'fileUseYnCode',
      type: 'string',
      map: 'fileUseYnCode',
    }, {
      name: 'fileContent',
      type: 'string',
      map: 'fileContent',
    }],
  }],
  computed: {},
  watch: {},
  mounted() {
    this.loadCode();
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadCode() {
      return http.mergeCodeList(this.pageId, CODE_KEYS, this.codes);
    },
    loadData() {
      if (utils.isEmpty(this.programId) === false) {
        http.request(this.pageId, 'DTS_CMS_00021', {
          path: {
            'program-id': this.programId,
          },
        }).then(res => {
          // utils.dateformatToClientInArray([res.data], dateTypeFields);

          this.frame1.moduleName = res.data.moduleName;
          this.frame1.subModuleName = res.data.subModuleName;
          this.frame1.moduleCode = res.data.moduleCode;
          this.frame1.subModuleCode = res.data.subModuleCode;
          // this.frame1.selectData.COD_MDLE.key = res.data.moduleCode;
          // this.frame1.selectData.COD_SMDLE.key = res.data.subModuleCode;
          this.frame1.programId = res.data.programId;
          this.frame1.programName = res.data.programName;
          this.frame1.selectData.COD_PRG_TYPE.key = res.data.programTypeCode;
          this.frame1.selectData.COD_PRG_TECHN.key = res.data.programTechnCode;
          this.frame1.selectData.useYn = res.data.programUseYnCode;
          this.frame1.programContents = res.data.programContents;
          this.frame1.firstRegistrationDTM = utils.dateformatToClient(res.data.firstRegistrationDTM);
          this.frame1.firstRegistrationUserId = res.data.firstRegistrationUserId;
          this.frame1.finalModificationDTM = utils.dateformatToClient(res.data.finalModificationDTM);
          this.frame1.finalModificationUserId = res.data.finalModificationUserId;
          this.frame1.fstDisplayLanguageId = res.data.fstDisplayLanguageId;
          this.frame1.fstKnoxId = res.data.fstKnoxId;
          this.frame1.fstUserName = res.data.fstUserName;
          this.frame1.fstUserGlobalName = res.data.fstUserGlobalName;
          this.frame1.fstDepartmentName = res.data.fstDepartmentName;
          this.frame1.fstDepartmentEnglishName = res.data.fstDepartmentEnglishName;
          this.frame1.fnlDisplayLanguageId = res.data.fnlDisplayLanguageId;
          this.frame1.fnlKnoxId = res.data.fnlKnoxId;
          this.frame1.fnlUserName = res.data.fnlUserName;
          this.frame1.fnlUserGlobalName = res.data.fnlUserGlobalName;
          this.frame1.fnlDepartmentName = res.data.fnlDepartmentName;
          this.frame1.fnlDepartmentEnglishName = res.data.fnlDepartmentEnglishName;
          this.attachGroupId = 'ATG_CMS_PRGS_COMMON';
          this.attachDocumentId = res.data.atthDocId;
          // this.$refs.fileAttacher.searchAttachedFileInfoByDocId(res.data.atthDocId);

          this.dsFileLst.setRawData(res.data.fileList);
        }).catch(error => {
          console.log(error);
        });
      }
    },
    onCancelClick() {
      this.$emit('close');
    },
    onDelClick() {
      utils.messageBox('confirm', this.$t('MSG_ALT_IS_DEL_DATA'), null, () => {
        http.request(this.pageId, 'DTS_CMS_00024', {
          query: {
            programIdList: this.frame1.programId,
          },
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'), null, this.research);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    onSaveClick() {
      // const programFileList = this.dsFileLst.data;
      const dataParams = {
        // moduleCode: utils.trim(this.frame1.selectData.COD_MDLE.key),
        // subModuleCode: utils.trim(this.frame1.selectData.COD_SMDLE.key),
        moduleCode: this.frame1.moduleCode,
        subModuleCode: this.frame1.subModuleCode,
        programId: this.frame1.programId,
        programName: this.frame1.programName,
        programTypeCode: utils.trim(this.frame1.selectData.COD_PRG_TYPE.key),
        programTechnCode: utils.trim(this.frame1.selectData.COD_PRG_TECHN.key),
        programUseYn: this.frame1.selectData.useYn,
        programContents: this.frame1.programContents,
      };
      const gridParams = {
        programFileList: this.dsFileLst.data,
      };

      if (this.validation(dataParams)) {
        if (this.validationGrid(gridParams)) {
          const fileList = gridParams.programFileList;
          let tmpFileNames = '';
          let tmpFilePaths = '';
          tmpFileNames = utils.map(fileList, 'fileName');
          tmpFilePaths = utils.map(fileList, 'filePath');
          // console.log('파일명 중복여부:', fileList.length === utils.uniq(tmpFileNames).length);
          // console.log('파일경로 중복여부:', fileList.length === utils.uniq(tmpFilePaths).length);
          if (fileList.length !== utils.uniq(tmpFileNames).length) {
            utils.messageBox('warning', this.$t('MSG_ALT_DUPLICATE_FILE_NAME'));
          } else if (fileList.length !== utils.uniq(tmpFilePaths).length) {
            utils.messageBox('warning', this.$t('MSG_ALT_DUPLICATE_FILE_PATH'));
          } else {
            this.onSave(dataParams, gridParams);
          }
        }
      } else {
        utils.messageBox('warning', this.validMessage);
      }
    },
    validation(data) {
      let validFlag = true;
      utils.forEach(data, (value, key) => {
        // if (!(utils.isEqual(key, 'programId'))) {
        if (utils.isEmpty(value)) {
          validFlag = false;
          switch (key) {
            case 'moduleCode':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE'));
              return false;
            case 'subModuleCode':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SMDLE'));
              return false;
            case 'programId':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRG_ID'));
              return false;
            case 'programName':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRG_NM'));
              return false;
            case 'programTypeCode':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PRG_TYPE'));
              return false;
            case 'programTechnCode':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PRG_TECHN'));
              return false;
            case 'programUseYn':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_USE_YN'));
              return false;
            case 'programContents':
              this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRG_CNTN'));
              return false;
            default:
              this.validMessage = '';
          }
          // }
        }
        return null;
      });
      return validFlag;
    },
    validationGrid(gridParams) {
      let validFlag = true;
      // utils.forEach(gridParams.programFileList, (value, key) => {
      utils.forEach(gridParams.programFileList, obj => {
        // const fileList = gridParams.programFileList;
        // for(let i in fileList) {
        if (utils.isEmpty(utils.trim(obj.fileName))) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT_FILE_NM'), obj.index));
          validFlag = false;
          return false;
        }
        if (utils.isEmpty(utils.trim(obj.filePath))) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT_FILE_PATH'), obj.index));
          validFlag = false;
          return false;
        }
        if (utils.isEmpty(utils.trim(obj.fileTypeCode)) || utils.trim(obj.fileTypeCode) === 'select') {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_SELECT_FILE_TYPE'), obj.index));
          validFlag = false;
          return false;
        }
        if (utils.isEmpty(utils.trim(obj.fileUseYnCode))) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_SELECT_USE_YN'), obj.index));
          validFlag = false;
          return false;
        }
        if (utils.isEmpty(utils.trim(obj.fileContent))) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT_CONTENT'), obj.index));
          validFlag = false;
          return false;
        }
        // }
        return null;
      });
      return validFlag;
    },
    onSave(dataParams, gridParams) {
      const regParams = {
        moduleCode: dataParams.moduleCode,
        subModuleCode: dataParams.subModuleCode,
        programId: dataParams.programId,
        programName: dataParams.programName,
        programTypeCode: dataParams.programTypeCode,
        programTechnCode: dataParams.programTechnCode,
        programUseYn: dataParams.programUseYn,
        programContents: dataParams.programContents,
        programFileList: gridParams.programFileList,
        attachFileList: this.$refs.fileAttacher.getAttachFileListInfo(),
      };
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        console.log(this.pageId);
        // if (!dataParams.programId) {
        http.request(this.pageId, 'DTS_CMS_00023', {
          data: regParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, this.research);
        }).catch(error => {
          console.log(error);
        });
        // }
      });
    },
    research() {
      this.$emit('saveClose');
    },
    onClickAddRow() {
      const defaultRow = [{
        fileName: '',
        filePath: '',
        fileTypeCode: 'select',
        fileUseYnCode: 'Y',
        fileContent: '',
      }];
      this.dsFileLst.addRows(defaultRow);
    },
    onClickDelRow() {
      // const selectedRows = [];
      const deleteRows = [];
      const selectedIndexes = this.dsFileLst.getSelectedIndexes();

      utils.forEach(selectedIndexes, index => {
        // selectedRows.push(this.dsFileLst.data[index]);

        if (utils.isEmpty(this.dsFileLst.data[index].rowType)) {
          deleteRows.push(this.dsFileLst.data[index]);
        }
      });

      this.dsFileLst.deleteRows(selectedIndexes);
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grdfilelist.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grdfilelist.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
  },
};
</script>
<style scoped>
</style>
